const LOCAL_STORAGE_KEY = 'ageConfirmed';
const YEAR_LIMIT = 20;
const YEAR_LIST_LIMIT = 100;

const isAgeConfirmed = (): boolean => !!window.localStorage.getItem(LOCAL_STORAGE_KEY);

const range = (from: number, to: number): number[] => {
  return [...Array(to - from + 1)].map((_, i) => from + i);
};

const createAgeConfirmModal = (): void => {
  if (isAgeConfirmed()) return;

  const currentYear = new Date().getFullYear();
  const defaultYear = currentYear - 20;

  const yearOptions = range(currentYear - YEAR_LIST_LIMIT, currentYear)
    .map(y => `<option value="${y}" ${y === defaultYear ? 'selected' : ''}>${y}年</option>`)
    .join('');
  const monthOptions = range(1, 12)
    .map(m => `<option value="${m}" ${m === 1 ? 'selected' : ''}>${m}月</option>`)
    .join('');
  const dayOptions = range(1, 31)
    .map(d => `<option value="${d}" ${d === 1 ? 'selected' : ''}>${d}日</option>`)
    .join('');

  const modalHTML = `
    <div id="age-confirm-modal" class="age-confirm-wrapper">
      <div class="age-confirm-container">
        <img src="https://whisky-auction-japan.s3.ap-northeast-1.amazonaws.com/assets/logo.png" alt="Whisky Auction Japan" class="age-confirm-logo" />
        <p class="age-confirm-description">
          20歳未満の飲酒は法律で禁止されております。<br/>
          適正飲酒の観点から20歳以上の方を対象としております。
        </p>
        <div id="age-confirm-form">
          <p class="age-confirm-description">あなたの生年月日を入力してください。</p>
          <div class="age-confirm-selects">
            <select id="age-confirm-year" class="age-confirm-select">${yearOptions}</select>
            <select id="age-confirm-month" class="age-confirm-select">${monthOptions}</select>
            <select id="age-confirm-day" class="age-confirm-select">${dayOptions}</select>
          </div>
          <p id="age-confirm-error" class="age-confirm-error"></p>
          <button id="age-confirm-button" class="age-confirm-button">Enter</button>
        </div>
        <div id="age-confirm-rejected" style="display: none;">
          <p class="age-confirm-description">
            申し訳ありません、あなたは法定年齢以下です。<br/>
            私達は私達のサイトであなたを歓迎することはできません。
          </p>
        </div>
      </div>
    </div>
  `;

  document.body.insertAdjacentHTML('beforeend', modalHTML);
  document.body.style.overflow = 'hidden';

  const button = document.getElementById('age-confirm-button');
  const errorEl = document.getElementById('age-confirm-error');
  const formEl = document.getElementById('age-confirm-form');
  const rejectedEl = document.getElementById('age-confirm-rejected');

  button?.addEventListener('click', () => {
    const year = parseInt((document.getElementById('age-confirm-year') as HTMLSelectElement).value);
    const month = parseInt((document.getElementById('age-confirm-month') as HTMLSelectElement).value);
    const day = parseInt((document.getElementById('age-confirm-day') as HTMLSelectElement).value);

    const birthDate = new Date(year, month - 1, day);
    const today = new Date();

    // Check if date is valid
    if (birthDate.getFullYear() !== year || birthDate.getMonth() !== month - 1 || birthDate.getDate() !== day) {
      if (errorEl) errorEl.textContent = '存在しない日付が入力されました。';
      return;
    }

    // Calculate age
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    if (age < YEAR_LIMIT) {
      if (formEl) formEl.style.display = 'none';
      if (rejectedEl) rejectedEl.style.display = 'block';
      return;
    }

    window.localStorage.setItem(LOCAL_STORAGE_KEY, '1');
    const modal = document.getElementById('age-confirm-modal');
    if (modal) modal.remove();
    document.body.style.overflow = '';
  });
};

document.addEventListener('DOMContentLoaded', createAgeConfirmModal);
